if (typeof boostPFSThemeConfig !== 'undefined') {

  // if no 3rd row promo then one less product pr page
  if (!boostPFSTemplate.promoImageUrl1x_1) {
    // Override Settings
    var boostPFSFilterConfig = {
      general: {
        limit: 15,
        /* Optional */
        loadProductFirst: false,
      },
    };
  }
  else {
    // Override Settings
    var boostPFSFilterConfig = {
      general: {
        limit: boostPFSConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false,
      },
    };
  }
}

(function () {
  BoostPFS.inject(this);
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    var fadeElement = '';
    fadeElement = jQ('.PageTransitionBoost');
    if (fadeElement) {
      fadeElement.addClass('active');
    }
    if (!data) data = this.data;
    if (!index) index = this.index;
    var soldOut = !data.available,
      onSale = data.compare_at_price_min > data.price_min,
      priceVaries = data.price_min != data.price_max,
      images = data.images_info;
    if (images.length == 0) {
      images.push({
        src: boostPFSConfig.general.no_image_url,
        id: data.id,
        width: 480,
        height: 480
      });
    }
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    //Promo image
    itemHtml = itemHtml.replace(/{{the_promo_image}}/g, promoImage(data, index));

    //Add class
    itemHtml = itemHtml.replace(/{{mobile_items_per_row}}/g, boostPFSConfig.custom.mobile_items_per_row);
    itemHtml = itemHtml.replace(/{{tablet_items_per_row}}/g, boostPFSConfig.custom.tablet_items_per_row);
    itemHtml = itemHtml.replace(/{{desktop_items_per_row}}/g, boostPFSConfig.custom.desktop_items_per_row);
    itemHtml = itemHtml.replace(/{{horizontal_class}}/g, boostPFSConfig.custom.horizontal_class);
    itemHtml = itemHtml.replace(/{{filter_position_class}}/g, boostPFSConfig.custom.filter_position);


    var has_alternate_image = false;
    if (images.length > 1 &&
      boostPFSConfig.custom.hasOwnProperty('product_show_secondary_image') &&
      boostPFSConfig.custom.product_show_secondary_image == true) {
      has_alternate_image = true;
    }
    itemHtml = itemHtml.replace(/{{has_alternate_image_class}}/g, has_alternate_image ? "ProductItem__ImageWrapper--withAlternateImage" : "");

    var use_natural_size = false;
    if (boostPFSConfig.custom.hasOwnProperty('product_image_size') &&
      boostPFSConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
      use_natural_size = true;
    }
    itemHtml = itemHtml.replace(/{{use_natural_size_class}}/g, use_natural_size ? "withFallback" : boostPFSConfig.custom.product_image_size);
    var media_aspect_ratio = images[0].width / images[0].height;
    var max_width = images[0].width;
    if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
    itemHtml = itemHtml.replace(/{{padding_bottom}}/g, use_natural_size ? 'padding-bottom: ' + (100 / media_aspect_ratio) + '%;' : '');
    itemHtml = itemHtml.replace(/{{media_aspect_ratio}}/g, media_aspect_ratio);
    itemHtml = itemHtml.replace(/{{max_width}}/g, max_width);

    var sizes0 = '200,400,600,700,800,900,1000,1200';
    var image_url = Utils.optimizeImage(images[0]['src'], '{width}x');
    itemHtml = itemHtml.replace(/{{image_url}}/g, image_url);
    itemHtml = itemHtml.replace(/{{supported_sizes}}/g, imageSize(sizes0, images[0]));
    itemHtml = itemHtml.replace(/{{featured_media_id}}/g, images[0].id);
    var featured_media_url = Utils.optimizeImage(images[0]['src'], '600x');
    itemHtml = itemHtml.replace(/{{featured_media_url}}/g, featured_media_url);




    var alternate_image = '';


    if (has_alternate_image && images.length > 1) {
      var sizes1 = '200,300,400,600,800,900,1000,1200';
      var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
      alternate_image += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + imageSize(sizes1, images[1]) + ']"  data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
    }
    itemHtml = itemHtml.replace(/{{alternate_image}}/g, alternate_image);

    var product_media1_url = featured_media_url;
    if (images.length > 1) {
      product_media1_url = Utils.optimizeImage(images[1]['src'], '600x');
    }
    itemHtml = itemHtml.replace(/{{product_media1_url}}/g, product_media1_url);



    // Add Label
    itemHtml = itemHtml.replace(/{{product_labels}}/g, buildLabels(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{product_info}}/g, buildInfo(data, index));

    var view_product = boostPFSConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSConfig.label.view_product + '</a>' : '';
    itemHtml = itemHtml.replace(/{{view_product}}/g, view_product);

    // Icon video
    var itemVideoIconHtml = '';
    if (Utils.getProductMetafield(data, 'custom', 'desktop_video') !== null) {
      itemVideoIconHtml += '<span class="Product__VideoBadge">';
      itemVideoIconHtml += '<svg class="Icon Icon--play" role="presentation" viewBox="0 0 24 24">';
      itemVideoIconHtml += '<path d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm-2 15.5V9l4.5 3.25L10 15.5z" fill="currentColor"></path>';
      itemVideoIconHtml += '</svg>';
      itemVideoIconHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemVideoIcon}}/g, itemVideoIconHtml);

    // Quick buy
    var variants_grid = 'large';
    if (data.variants.length < 4) {
      variants_grid = 'small'
    } else if (data.variants.length < 5) {
      variants_grid = 'medium'
    }
    var itemQuickBuyMobileHtml = '';
    itemQuickBuyMobileHtml += '<div class="QuickBuy QuickBuy--mobile" data-quickbuy-id="' + boostPFSConfig.custom.section_id + '{{itemId}}">';
    itemQuickBuyMobileHtml += '<div class="QuickBuyMobile__Content">';
    itemQuickBuyMobileHtml += '<div class="Heading u-h8 QuickBuy__Heading">';
    itemQuickBuyMobileHtml += boostPFSConfig.label.choose_size;
    itemQuickBuyMobileHtml += '</div>';
    itemQuickBuyMobileHtml += '<button class="QuickBuyMobile__Close Icon-Wrapper--clickable" onclick="window.closeQuickBuyMobile()">';
    itemQuickBuyMobileHtml += '<svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">';
    itemQuickBuyMobileHtml += '<path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path>';
    itemQuickBuyMobileHtml += '</svg>';
    itemQuickBuyMobileHtml += '</button>';

    itemQuickBuyMobileHtml += '<ul class="QuickBuyVariants QuickBuyVariants--' + variants_grid + '">';
    for (var i = 0; i < data.variants.length; i++) {
      var variant = data.variants[i];
      var action = "window.addToCart('" + variant.id + "', event)";
      itemQuickBuyMobileHtml += '<li class="QuickBuyVariants__Item ' + (variant.available ? '' : 'QuickBuyVariant--unavailable') + '" onclick="' + action + '">' + variant.option1 + '</li>';
    }
    itemQuickBuyMobileHtml += '</ul>';
    itemQuickBuyMobileHtml += '</div>';
    itemQuickBuyMobileHtml += '</div>';

    itemHtml = itemHtml.replace(/{{itemQuickBuyMobile}}/g, itemQuickBuyMobileHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
    }
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
    itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));


    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildClass() {
    return boostPFSConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
  }

  function buildClassHiz() {
    return boostPFSConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
  }

  function imageSize(sizes, image) {
    if (image) {
      var desired_sizes = sizes.split(',');
      var supported_sizes = '';
      for (var k = 0; k < desired_sizes.length; k++) {
        var size = desired_sizes[k];
        var size_as_int = size * 1;
        if (image.width < size_as_int) { break; }
        supported_sizes = supported_sizes + size + ',';
      }

      if (supported_sizes == '') supported_sizes = image.width;

      if (!jQ.isNumeric(supported_sizes)) {
        supported_sizes = supported_sizes.split(',').join(',');
        supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(','));
      }
      return supported_sizes;
    } else {
      return '';
    }
  }

  function buildPrice(data) {
    var html = '';
    var show_price_on_hover = boostPFSConfig.custom.product_show_price_on_hover;
    var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
    html += '<div class="ProductItem__PriceList ' + classPriceHover + '">';
    if (data.compare_at_price_min > data.price_min) {
      html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span> ';
      html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
    } else {
      if (data.price_min != data.price_max) {
        html += '<span class="ProductItem__Price Price Text--subdued">' + boostPFSConfig.label.from_price_html.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)) + '</span>';
      } else {
        html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span>';
      }
    }
    html += '</div>';
    return html;
  }

  function buildLabels(data) {
    var html = '';
    var product_labels = '';
    if (boostPFSConfig.custom.show_labels) {
      product_labels = '';
      var tags = data.tags;
      for (var k = 0; k < tags.length; k++) {
        var tag = tags[k];
        if (tag.indexOf('__label') != -1) {
          product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + tag.split('__label:')[1] + '</span>';
          break;
        }
      }
      if (data.available) {
        if (data.compare_at_price_min > data.price_min)
          product_labels += '<span class="ProductItem__Label Heading Text--subdued">' + boostPFSConfig.label.sale + '</span>';
      } else {
        product_labels += ' <span class="ProductItem__Label Heading Text--subdued">' + boostPFSConfig.label.sold_out + '</span>';
      }

      if (product_labels != '') {
        html += '<div class="ProductItem__LabelList">';
        html += product_labels;
        html += '</div>';
      }
    }
    return html;
  }

  function buildInfo(data, indx) {
    var html = '';
    if (boostPFSConfig.custom.show_product_info) {
      var infoClass = (!boostPFSConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSConfig.custom.product_info_alignment : '';
      html += '<div class="ProductItem__Info ' + infoClass + '">';
      var itemQuickBuyHtml = '';

        // Quickbuy button
        itemQuickBuyHtml += '<button type="button" class="QuickBuy__MobileTrigger" onclick="window.openQuickBuyMobile(\'' + boostPFSConfig.custom.section_id + '{{itemId}}\')">';
        itemQuickBuyHtml += '<span class="QuickBuy__MobileTrigger--svg"><svg class="Icon Icon--cart" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">';
        itemQuickBuyHtml += '<path d="M13.6262 9.25V4.75C13.6262 3.75544 13.2311 2.80161 12.5279 2.09835C11.8246 1.39509 10.8708 1 9.87621 1C8.88164 1 7.92782 1.39509 7.22456 2.09835C6.52129 2.80161 6.12621 3.75544 6.12621 4.75V9.25M17.4822 7.257L18.7452 19.257C18.8152 19.922 18.2952 20.5 17.6262 20.5H2.12621C1.96841 20.5002 1.81235 20.4671 1.66815 20.4031C1.52396 20.339 1.39485 20.2453 1.28923 20.1281C1.1836 20.0108 1.10382 19.8727 1.05506 19.7226C1.0063 19.5726 0.989655 19.4139 1.00621 19.257L2.27021 7.257C2.29936 6.98056 2.42983 6.7247 2.63646 6.53876C2.84308 6.35281 3.11123 6.24995 3.38921 6.25H16.3632C16.9392 6.25 17.4222 6.685 17.4822 7.257ZM6.50121 9.25C6.50121 9.34946 6.4617 9.44484 6.39137 9.51517C6.32104 9.58549 6.22566 9.625 6.12621 9.625C6.02675 9.625 5.93137 9.58549 5.86104 9.51517C5.79071 9.44484 5.75121 9.34946 5.75121 9.25C5.75121 9.15054 5.79071 9.05516 5.86104 8.98483C5.93137 8.91451 6.02675 8.875 6.12621 8.875C6.22566 8.875 6.32104 8.91451 6.39137 8.98483C6.4617 9.05516 6.50121 9.15054 6.50121 9.25ZM14.0012 9.25C14.0012 9.34946 13.9617 9.44484 13.8914 9.51517C13.821 9.58549 13.7257 9.625 13.6262 9.625C13.5267 9.625 13.4314 9.58549 13.361 9.51517C13.2907 9.44484 13.2512 9.34946 13.2512 9.25C13.2512 9.15054 13.2907 9.05516 13.361 8.98483C13.4314 8.91451 13.5267 8.875 13.6262 8.875C13.7257 8.875 13.821 8.91451 13.8914 8.98483C13.9617 9.05516 14.0012 9.15054 14.0012 9.25Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>';
        itemQuickBuyHtml += '</svg></span>';
        itemQuickBuyHtml += '<span class="QuickBuy__MobileTrigger--text">' + boostPFSTemplate.quickbuy_text + '</span>';
        itemQuickBuyHtml += '</button>';



      var variants_grid = 'large';
      if (data.variants.length < 4) {
        variants_grid = 'small'
      } else if (data.variants.length < 5) {
        variants_grid = 'medium'
      }

      itemQuickBuyHtml += '<div class="QuickBuy QuickBuy--productItem">';
      itemQuickBuyHtml += '<div class="Heading u-h8 QuickBuy__Heading">';
      itemQuickBuyHtml += '<svg class="Icon Icon--cart" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">';
      itemQuickBuyHtml += '<path d="M13.6262 9.25V4.75C13.6262 3.75544 13.2311 2.80161 12.5279 2.09835C11.8246 1.39509 10.8708 1 9.87621 1C8.88164 1 7.92782 1.39509 7.22456 2.09835C6.52129 2.80161 6.12621 3.75544 6.12621 4.75V9.25M17.4822 7.257L18.7452 19.257C18.8152 19.922 18.2952 20.5 17.6262 20.5H2.12621C1.96841 20.5002 1.81235 20.4671 1.66815 20.4031C1.52396 20.339 1.39485 20.2453 1.28923 20.1281C1.1836 20.0108 1.10382 19.8727 1.05506 19.7226C1.0063 19.5726 0.989655 19.4139 1.00621 19.257L2.27021 7.257C2.29936 6.98056 2.42983 6.7247 2.63646 6.53876C2.84308 6.35281 3.11123 6.24995 3.38921 6.25H16.3632C16.9392 6.25 17.4222 6.685 17.4822 7.257ZM6.50121 9.25C6.50121 9.34946 6.4617 9.44484 6.39137 9.51517C6.32104 9.58549 6.22566 9.625 6.12621 9.625C6.02675 9.625 5.93137 9.58549 5.86104 9.51517C5.79071 9.44484 5.75121 9.34946 5.75121 9.25C5.75121 9.15054 5.79071 9.05516 5.86104 8.98483C5.93137 8.91451 6.02675 8.875 6.12621 8.875C6.22566 8.875 6.32104 8.91451 6.39137 8.98483C6.4617 9.05516 6.50121 9.15054 6.50121 9.25ZM14.0012 9.25C14.0012 9.34946 13.9617 9.44484 13.8914 9.51517C13.821 9.58549 13.7257 9.625 13.6262 9.625C13.5267 9.625 13.4314 9.58549 13.361 9.51517C13.2907 9.44484 13.2512 9.34946 13.2512 9.25C13.2512 9.15054 13.2907 9.05516 13.361 8.98483C13.4314 8.91451 13.5267 8.875 13.6262 8.875C13.7257 8.875 13.821 8.91451 13.8914 8.98483C13.9617 9.05516 14.0012 9.15054 14.0012 9.25Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>';
      itemQuickBuyHtml += '</svg>';
      itemQuickBuyHtml += '<span>' + boostPFSConfig.label.choose_size + '</span>';
      itemQuickBuyHtml += '</div>';
      itemQuickBuyHtml += '<ul class="QuickBuyVariants QuickBuyVariants--' + variants_grid + '">';
      for (var i = 0; i < data.variants.length; i++) {
        var variant = data.variants[i];
        var sizes = variant.option1.split(' ');
        var action = "window.addToCart('" + variant.id + "', event)";
        itemQuickBuyHtml += '<li class="QuickBuyVariants__Item ' + (variant.available ? '' : 'QuickBuyVariant--unavailable') + '" onclick="' + action + '">';
        for (var j = 0; j < sizes.length; j++) {
          itemQuickBuyHtml += '<span>' + sizes[j] + '</span>';
        }
      }
      itemQuickBuyHtml += '</li>';
      itemQuickBuyHtml += '</ul>';
      itemQuickBuyHtml += '</div>';
      html += itemQuickBuyHtml;

      if (boostPFSConfig.custom.show_vendor) {
        html += '<p class="ProductItem__Vendor Heading">' + data.vendor + '</p>'
      }

      function truncate(str, limit){
        if (str.length > limit){
          str = str.substr(0,limit);
        }
        else{ return str; }
        return str;
      }

      html += '<h2 class="ProductItem__Title">';
      html += '<a href="{{itemUrl}}">';
      if (data.title.includes(' - ')) {
        const title = data.title.split(' - ').shift();
        const variant = data.title.split(' - ').pop();

        html += '<span class="Heading u-h6">' + title + '</span>';
        html += '<span class="ProductItem__TitleColor u-h7">' + variant +'</span>';
      }
      else {
        html += '<span class="Heading u-h6">' + data.title + '</span>';
      }
      html += '</a>';
      html += '</h2>';


      /* html += '<h2 class="ProductItem__Title">';
      html += '<a href="{{itemUrl}}">' + data.title + '</a>';
      html += '</h2>'; */
      html += '{{itemReviews}}';
      html += buildPrice(data);
      if (boostPFSConfig.custom.show_color_swatch) {
        html += buildSwatch(data, indx);
      }
      html += '</div>';
    }

    return html;
  }

  function promoImage(data, indx) {
    promoImageHtml = '';
    var productCount = 1;
    productCount = productCount+indx;
    //Promo first row - third element

    if (productCount === 7 && boostPFSTemplate.promoImageWidth_1 == '2/3' && boostPFSTemplate.promoImageUrl1x_1) {
      promoImageHtml += `<div class="Grid__Cell 2/4--lap-and-up CollectionPromo CollectionPromo--Half" >`
        if (boostPFSTemplate.promoImageLink_1) {
          promoImageHtml += `<a href="` + boostPFSTemplate.promoImageLink_1 + `">`;
        }
          promoImageHtml += `<div class="CollectionPromo__ImageWrapper" style="background: url(` + boostPFSTemplate.promoImageUrl1x_1 + `)">
            <div class="CollectionPromo__Image Image--lazyLoad Image--zoomOut hide-no-js AspectRatio" style="max-width: 1200px; data-expand="-25"; data-bgset="` + boostPFSTemplate.promoImageUrl800x_1 + ` [(max-width: 640px)] | ` + boostPFSTemplate.promoImageUrl1200x_1 + `">
              <div class="CollectionItem__Content CollectionItem__Content--bottomCenter">
                <header class="SectionHeader">
                  <h2 class="SectionHeader__Heading Heading u-h2">` + boostPFSTemplate.promoImageHeader_1 + `</h2>
                  <div class="SectionHeader__ButtonWrapper">
                    <span class="CollectionItem__Link">` + boostPFSTemplate.promoImageLinkText_1 + `</span>
                  </div>
                </header>
              </div>
            </div>

            <noscript>
              <div class="CollectionPromo__Image" style="background-image: url(` + boostPFSTemplate.promoImageUrl800x_1 + `)"></div>
            </noscript>
          </div>`
        if (boostPFSTemplate.promoImageLink_1) {
           promoImageHtml += `</a>`
         }
        promoImageHtml += `</div>`
    }


    //Promo banner

    var positionPromo2 = 13;

    if (boostPFSTemplate.promoImageUrl1x_1) {
      positionPromo2 = 11;
    }

    if (productCount === positionPromo2 && boostPFSTemplate.promoBannerHeader != "") {
      promoImageHtml += `<div class="Grid__Cell 2/4--lap-and-up CollectionPromo CollectionPromo--banner" style="background: #` + boostPFSTemplate.promoBannerColor + `">`

          promoImageHtml += `<h2 class="SectionHeader__Heading Heading u-h2">` + boostPFSTemplate.promoBannerHeader + `</h2>`;
          promoImageHtml += `<div class="CollectionPromo--svg">` + boostPFSTemplate.promoBannerIcon + `</div>`;

        promoImageHtml += `</div>`
    }

    //Promo first row - third element
    return promoImageHtml;
  }




  function buildSwatch(data, indx) {
    var itemSwatchHtml = '';
    if (boostPFSConfig.custom.show_color_swatch) {
      var color_name = boostPFSConfig.custom.section_id + '-' + data.id + '-' + indx;
      data.options_with_values.forEach(function (option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
          var values = '';
          itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
          var i = 0;
          data.variants.forEach(function (variant) {
            var temp = variant.merged_options.filter(function (obj) {
              obj = obj.toLowerCase();
              if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
                return obj;
            });
            temp = temp[0].split(':');

            var value = temp[1].toLowerCase();
            if (values.indexOf(value) == -1) {
              values = values + ',' + value;
              values = values.split(',');
              var size = '200,400,600,700,800,900,1000,1200';
              var supported_sizes = imageSize(size, variant.image);
              var color_image = Utils.optimizeImage(variant.image);
              var name_color = Utils.slugify(value) + '.png';
              var checked = (i == 0) ? 'checked=checked' : '';
              var imageInfo = null;
              var image_aspect_ratio = 1;
              imageInfo = data.images_info.find(function (imageOb) {
                if (imageOb.src == variant.image) {
                  image_aspect_ratio = imageOb.width / imageOb.height;
                  return imageOb;
                }
              });
              if (!imageInfo) {
                if (data.images_info.length > 0) {
                  imageInfo = data.images_info[0];
                } else {
                  imageInfo = {
                    src: boostPFSConfig.general.no_image_url,
                    id: variant.id,
                    width: 480,
                    height: 480
                  }
                }

              }
              var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
              var color_input_id = color_name + "-" + values.length;
              var variant_price = variant.price ? variant.price : 0;
              var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
              var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
              itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
              itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' + imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
              itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
              itemSwatchHtml += '</div>';
              i++;
            }
          });
          itemSwatchHtml += '</div>';
        }
      });
    }
    return itemSwatchHtml;
  }
  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
          sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    var topSortingSelector = jQ(Selector.topSorting);
    topSortingSelector.find('.Popover__Value').click(function (e) {
      FilterApi.setParam('sort', jQ(this).data('value'));
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
      jQ('.CollectionToolbar__Item--sort').trigger('click');
    });
  }
  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
    /**
     *  Call theme function
     *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
     *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
     *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;

    if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
    bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
    bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
    }
    */

    // Fix image not load on Instagram browser - initialize swatch image
    jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function () {
      jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
      jQ(this).addClass('active');
      var parent = jQ(this).parent();
      var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
      var variantInfo = parent.find('input.ColorSwatch__Radio');
      productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
      productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
      productImage.find('img.ProductItem__Image').hide();
      productImage.attr('href', variantInfo.data('variant-url'));
      var variantPrice = '';
      if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')) {
        variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
        variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
      } else {
        variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
      }
      jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
    })

    //Change view layout
    var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
    if (desktopView && desktopView != parseInt(boostPFSConfig.custom.desktop_row)) {
      jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSConfig.custom.desktop_row + '--' + buildClass());
      jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
    }
    var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
    if (mobileView && mobileView != parseInt(boostPFSConfig.custom.mobile_row)) {
      jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSConfig.custom.mobile_row + '--phone');
      jQ(Selector.products + ' .Grid__Cell').addClass('1/' + mobileView + '--phone');
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;
  };

  // Build Default layout
  Filter.prototype.errorFilterCallback = function () { var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, isSafari = /Safari/.test(navigator.userAgent), isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type; if (!(isiOS && isSafari && isBackButton)) { var self = this, url = window.location.href.split("?")[0], searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : ""; window.location.replace(url + "?view=bc-original" + searchQuery) } };
})();
